
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.08 10.58H1.5A1.5 1.5 0 010 9.08V1.5A1.5 1.5 0 011.5 0h7.58a1.5 1.5 0 011.5 1.5v7.58a1.5 1.5 0 01-1.5 1.5zM1.5 1a.5.5 0 00-.5.5v7.58a.5.5 0 00.5.5h7.58a.5.5 0 00.5-.5V1.5a.5.5 0 00-.5-.5zm21 9.58h-7.58a1.5 1.5 0 01-1.5-1.5V1.5a1.5 1.5 0 011.5-1.5h7.58A1.5 1.5 0 0124 1.5v7.58a1.5 1.5 0 01-1.5 1.5zM14.92 1a.5.5 0 00-.5.5v7.58a.5.5 0 00.5.5h7.58a.5.5 0 00.5-.5V1.5a.5.5 0 00-.5-.5zM9.08 24H1.5A1.5 1.5 0 010 22.5v-7.58a1.5 1.5 0 011.5-1.5h7.58a1.5 1.5 0 011.5 1.5v7.58a1.5 1.5 0 01-1.5 1.5zM1.5 14.42a.5.5 0 00-.5.5v7.58a.5.5 0 00.5.5h7.58a.5.5 0 00.5-.5v-7.58a.5.5 0 00-.5-.5zm21 9.58h-7.58a1.5 1.5 0 01-1.5-1.5v-7.58a1.5 1.5 0 011.5-1.5h7.58a1.5 1.5 0 011.5 1.5v7.58a1.5 1.5 0 01-1.5 1.5zm-7.58-9.58a.5.5 0 00-.5.5v7.58a.5.5 0 00.5.5h7.58a.5.5 0 00.5-.5v-7.58a.5.5 0 00-.5-.5z"}})])
          )
        }
      }
    